import { render, staticRenderFns } from "./RedmineIssuesList.vue?vue&type=template&id=ddbb4656&scoped=true"
import script from "./RedmineIssuesList.vue?vue&type=script&lang=js"
export * from "./RedmineIssuesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbb4656",
  null
  
)

export default component.exports